import { render, staticRenderFns } from "./PainelProcessoLegadoVisualizacao.vue?vue&type=template&id=85e1190c&scoped=true"
import script from "./PainelProcessoLegadoVisualizacao.vue?vue&type=script&lang=js"
export * from "./PainelProcessoLegadoVisualizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e1190c",
  null
  
)

export default component.exports